import { assign, pick } from 'lodash-es'
import * as React from 'react'
import { useRouteNode } from 'react-router5'
import { CancelFn, State } from 'router5/types/types/base'
import { InitialValueFn, useLocalStorage } from './useLocalStorage'

/** TODO: rename to useRouteNodeParams, use same api as useRouteNode hook */
export function useRouteParams<T>(
  nodeName: string,
  defaults: T | InitialValueFn<T>,
  options: { persist?: boolean | string[] } = {}
): [T, (updateParams: Partial<T>) => CancelFn, State] {
  const { route, router } = useRouteNode(nodeName)
  const [localState, setLocalState] = useLocalStorage<T>(
    `@emos/routing/${route.name}`,
    defaults
  )

  const paramsRef = React.useRef<T>(assign({}, localState, route.params) as T)
  const optionsRef = React.useRef(options)

  const navigate = React.useCallback(
    (params: any) => router.navigate(route.name, params),
    [route.name, router]
  )
  const updateParams = React.useCallback(
    (input: Partial<T>, replace?: boolean) => {
      const { persist } = optionsRef.current

      const params = (paramsRef.current = replace
        ? input
        : (assign({}, paramsRef.current, input) as any))

      if (persist) {
        setLocalState(
          Array.isArray(persist) ? (pick(params, persist) as any) : params
        )
      }

      return navigate(params)
    },
    [navigate, setLocalState, optionsRef]
  )

  // probably not needed
  // React.useEffect(
  //   () =>
  //     router.subscribe(state => {
  //       if (
  //         state.route.name === state.previousRoute.name &&
  //         !isEqual(paramsRef.current, state.route.params)
  //       ) {
  //         // tslint:disable-next-line:no-debugger
  //         debugger
  //         updateParams(state.route.params as T)
  //       }
  //     }) as any,
  //   [router, paramsRef, updateParams]
  // )

  return [paramsRef.current, updateParams, route]
}
